import React from 'react';
import { Users, Mail, Calendar, Send } from 'lucide-react';

export function StatsCards({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
      <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Users className="text-teal-400" size={24} />
          <span className="text-gray-400 text-sm">Total Subscribers</span>
        </div>
        <p className="text-3xl font-bold">{stats.total_subscribers}</p>
      </div>
      <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Mail className="text-green-400" size={24} />
          <span className="text-gray-400 text-sm">Active Subscribers</span>
        </div>
        <p className="text-3xl font-bold">{stats.active_subscribers}</p>
      </div>
      <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Calendar className="text-gold-400" size={24} />
          <span className="text-gray-400 text-sm">Total Inquiries</span>
        </div>
        <p className="text-3xl font-bold">{stats.total_inquiries}</p>
      </div>
      <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Calendar className="text-blue-400" size={24} />
          <span className="text-gray-400 text-sm">New Inquiries</span>
        </div>
        <p className="text-3xl font-bold">{stats.new_inquiries}</p>
      </div>
      <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
        <div className="flex items-center gap-3 mb-2">
          <Send className="text-purple-400" size={24} />
          <span className="text-gray-400 text-sm">Newsletters Sent</span>
        </div>
        <p className="text-3xl font-bold">{stats.newsletters_sent || 0}</p>
      </div>
    </div>
  );
}
